import React from 'react';

import { Dimmable } from '../../../Dimmable';
import { VSpacer24 } from '../../../Elements';
import { ArtistFundraisingPickUpdateBody } from './ArtistFundraisingPickUpdateBody';
import { ArtistFundraisingPickUpdateFooter } from './ArtistFundraisingPickUpdateFooter';
import { Title, TitleActions } from '../shared';
import type { Alertable } from '../types';

type Props = { url: string } & Alertable;

export function ArtistFundraisingPickUpdate(props: Props) {
  const [isEditing, setIsEditing] = React.useState(false);

  return (
    <Dimmable active={isEditing}>
      <div>
        <Title>
          <TitleActions
            isEditing={isEditing}
            setAlert={props.setAlert}
            setIsEditing={setIsEditing}
          />
        </Title>
        <ArtistFundraisingPickUpdateBody url={props.url} />
        <ArtistFundraisingPickUpdateFooter
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
        <VSpacer24 />
      </div>
    </Dimmable>
  );
}
